import { UIRouterModule } from '@uirouter/angular';
import * as fromReconciliation from '.';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild({
            // TODO: will having all these here mess with lazy loading of modules?
            // https://ui-router.github.io/guide/lazyloading
            states: [
                {
                    // name: 'efcheckup.**',
                    name: 'recon',
                    url: '/recon',
                    // loadChildren: () => import('./checkup.module').then(r => r.CheckupModule),
                    data: { requiresAuth: true },
                    component:
                        fromReconciliation.ReconciliationContainerComponent
                },
                {
                    name: 'recon.timecard',
                    url: '/timecard',
                    data: { requiresAuth: true },
                    component:
                        fromReconciliation.ReconciliationContainerComponent
                },
                {
                    name: 'recon.fringe-labor',
                    url: '/fringe-labor',
                    data: { requiresAuth: true },
                    component:
                        fromReconciliation.ReconciliationContainerComponent
                },
                {
                    name: 'recon.pay-period-labor',
                    url: '/pay-period-labor',
                    data: { requiresAuth: true },
                    component:
                        fromReconciliation.ReconciliationContainerComponent
                }
            ]
        })
    ]
})
export class ReconciliationRouteModule {}
